import { api } from "../api";
import axios from "axios";

const authHeaders = () => ({
  headers: {
    Authorization: "Bearer " + localStorage.getItem("token"),
    Accept: "application/json",
  },
});

export const getSuperAdminDashboard = async () => {
  const res = await axios.get(api + "superadmin/dashboard", authHeaders());
  return res.data;
};
